var map = {
	"./Admin/routes.ts": "/5NM",
	"./Collect/routes.ts": "GCB9",
	"./ErrorOverview/routes.ts": "u+Bj",
	"./Errors/Detail/routes.tsx": "bCuy",
	"./Errors/routes.ts": "E/pm",
	"./Project/modules/Create/routes.ts": "RWUX",
	"./Project/modules/Detail/routes.tsx": "5wgO",
	"./Project/routes.ts": "9A1U",
	"./Team/TeamDetail/routes.ts": "Hp5W",
	"./Team/routes.ts": "j+xW"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Vmlr";